import React, { useEffect, useState } from 'react';
import { fetchLatestData } from '../redux/action/customFile';
import PageLoader from '../shared/PageLoader';
import './HotelsList.css';

const toCount = (value) => {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
};

export default function HotelsList() {
    const [hotelsList, setHotelsList] = useState([]);
    const [search, setSearch] = useState("");
    const [cityFilter, setCityFilter] = useState("ALL");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        fetchLatestData(
            "hotles/get/all/list",
            {},
            (data) => {
                setHotelsList(Array.isArray(data) ? data : []);
                setLoading(false);
            },
            (err) => {
                console.log(err);
                setLoading(false);
                setError("Unable to load hotels.");
            }
        );
    }, []);

    const rows = hotelsList.filter((item) => {
        if (cityFilter !== "ALL" && (item.city || "").toUpperCase() !== cityFilter) return false;
        const lowerSearch = (search || "").toLowerCase();
        if (!lowerSearch) return true;
        const name = (item.name || "").toString().toLowerCase();
        const city = (item.city || "").toString().toLowerCase();
        return name.includes(lowerSearch) || city.includes(lowerSearch);
    });

    const totalBeds = rows.reduce((sum, item) => sum + toCount(item.totalBeds), 0);
    const availableBeds = rows.reduce((sum, item) => sum + toCount(item.availableBeds), 0);
    const occupiedBeds = Math.max(0, totalBeds - availableBeds);

    return (
        <div className="ht-page">
            <div className="ht-header">
                <div>
                    <h3>Hotels available</h3>
                    <p>Bed inventory for Madina and Makkah properties.</p>
                </div>
                <span className="ht-count">{loading ? "Loading…" : `${rows.length} hotel${rows.length === 1 ? "" : "s"}`}</span>
            </div>

            {error && <div className="ht-banner">{error}</div>}

            {loading ? (
                <PageLoader title="Loading hotels" message="Please wait while we fetch hotel inventory." />
            ) : (
            <>
            <div className="ht-kpis">
                <div className="ht-kpi">
                    <div className="ht-kpi-icon" style={{ background: "#eff6ff", color: "#1a73e8" }}>
                        <span className="mdi mdi-hotel" />
                    </div>
                    <div>
                        <p>Total beds</p>
                        <h4>{totalBeds}</h4>
                    </div>
                </div>
                <div className="ht-kpi">
                    <div className="ht-kpi-icon" style={{ background: "#ecfdf5", color: "#059669" }}>
                        <span className="mdi mdi-bed-empty" />
                    </div>
                    <div>
                        <p>Available</p>
                        <h4>{availableBeds}</h4>
                    </div>
                </div>
                <div className="ht-kpi">
                    <div className="ht-kpi-icon" style={{ background: "#fff7ed", color: "#ea580c" }}>
                        <span className="mdi mdi-account-group" />
                    </div>
                    <div>
                        <p>Occupied</p>
                        <h4>{occupiedBeds}</h4>
                    </div>
                </div>
            </div>

            <div className="ht-card">
                <div className="ht-toolbar">
                    <div className="ht-search">
                        <span className="mdi mdi-magnify" />
                        <input
                            type="search"
                            name="search"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="Search hotel or city"
                        />
                    </div>
                    <div className="ht-filters">
                        <button type="button" className={`ht-chip ${cityFilter === "ALL" ? "active" : ""}`} onClick={() => setCityFilter("ALL")}>All</button>
                        <button type="button" className={`ht-chip ${cityFilter === "MADINA" ? "active" : ""}`} onClick={() => setCityFilter("MADINA")}>Madina</button>
                        <button type="button" className={`ht-chip ${cityFilter === "MAKKAH" ? "active" : ""}`} onClick={() => setCityFilter("MAKKAH")}>Makkah</button>
                    </div>
                </div>

                <div className="ht-table-wrap">
                    <table className="ht-table">
                        <thead>
                            <tr>
                                <th>Hotel</th>
                                <th>City</th>
                                <th>Total beds</th>
                                <th>Available</th>
                                <th>Occupancy</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((item, index) => {
                                const total = toCount(item.totalBeds);
                                const available = toCount(item.availableBeds);
                                const occupied = Math.max(0, total - available);
                                const pct = total ? Math.round((occupied / total) * 100) : 0;
                                const barColor = pct >= 90 ? "#dc2626" : pct >= 70 ? "#d97706" : "#059669";
                                const city = (item.city || "").toUpperCase();
                                const cityTone = city === "MAKKAH"
                                    ? { bg: "#f5f3ff", color: "#6d28d9" }
                                    : { bg: "#eff6ff", color: "#1d4ed8" };
                                return (
                                    <tr key={item.id || item.name || index}>
                                        <td className="ht-name">{item.name || "—"}</td>
                                        <td>
                                            <span className="ht-city" style={{ background: cityTone.bg, color: cityTone.color }}>
                                                {item.city || "—"}
                                            </span>
                                        </td>
                                        <td>{total}</td>
                                        <td>{available}</td>
                                        <td>
                                            <div className="ht-occ">
                                                <div className="ht-occ-meta">
                                                    <span>{occupied} occupied</span>
                                                    <span>{pct}%</span>
                                                </div>
                                                <div className="ht-bar">
                                                    <span style={{ width: `${Math.min(pct, 100)}%`, background: barColor }} />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    {!rows.length && (
                        <div className="ht-empty">
                            <span className="mdi mdi-hotel" style={{ fontSize: "1.7rem" }} />
                            <h4>No hotels found</h4>
                            <p>Try a different city or search term.</p>
                        </div>
                    )}
                </div>
            </div>
            </>
            )}
        </div>
    );
}
